import { FormControlLabel, Switch, TextField } from "@mui/material";
import { Box } from "@mui/system";
import { Fragment } from "react";
import { Controller } from "react-hook-form";

export const CancelForm = ({ form }) => {
	const {
		control,
		register,
		formState: { errors },
	} = form;

	return (
		<Fragment>
			<Box my={3}>
				<Controller
					name="out_of_stock"
					control={control}
					defaultValue={false}
					render={({ field }) => (
						<FormControlLabel
							control={
								<Switch
									{...field}
									checked={field.value}
								// onChange={(e) =>
								// 	// field.onChange(product.out_of_stock)
								// }
								// disabled
								// sx={{ pointerEvents: "none" }}
								/>
							}
							label="Out of Stock"
							labelPlacement="start"
						/>
					)}
				/>
			</Box>

			<Box my={3}>
				<TextField
					// InputLabelProps={{ shrink: true }}
					{...register("reason", {})}
					fullWidth
					label="Reason (Optional)"
					variant="outlined"
					multiline
					minRows={3}
					// value={brand.name}
					error={Boolean(errors.reason)}
					helperText={errors.reason?.message}
				/>
			</Box>
		</Fragment>
	);
};
